import { Button, Loading, TextArea } from "@alm/flow-ds/components";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	description?: string;
	setDescription: Dispatch<SetStateAction<string | undefined>>;
	onUpdateRole?: (data: { description?: string }) => void;
	loading?: boolean;
	systemRole?: boolean;
}

export default ({
	description,
	setDescription,
	onUpdateRole,
	loading,
	systemRole,
}: Props) => {
	const { t } = useTranslation();

	return (
		<div className="admin__role-form__desc">
			<TextArea
				className="admin__role-form__desc-input"
				label={t("main.admin.labels.roleDesc")}
				onChange={e => setDescription(e.target.value)}
				value={description}
				disabled={systemRole}
			/>
			{onUpdateRole && (
				<Button
					label={!loading && t("main.admin.labels.updateDesc")}
					className="btn-tertiary admin__role-form__desc-btn"
					disabled={systemRole}
					onClick={() => onUpdateRole({ description })}>
					{loading && <Loading />}
				</Button>
			)}
		</div>
	);
};
